// extracted by mini-css-extract-plugin
export var accordion = "accordion-hs-module--accordion--e0aea";
export var headlineSizeSmall = "accordion-hs-module--headline-size-small--17e77";